import BigNumber from 'bignumber.js'

export const addUnitSuffix = (value: number, type: 'number' | 'byte' | '%', toFixedNum = 1) => {
  const SI_SYMBOL = {
    number: ['', ' K', ' M', ' B', ' T'],
    byte: ['', '  KB', ' MB', ' GB', ' TB'],
  }

  if (type === '%') return `${value.toFixed(2)} %`

  let tier = (Math.log10(value) / 3) | 0
  if (tier > 4) {
    tier = 4
  }

  const suffix = SI_SYMBOL[type][tier]
  const scale = 10 ** (tier * 3)
  let capacity

  if (tier === 0) {
    capacity = value
  } else {
    capacity = numFloorFixed(value / scale, toFixedNum)
  }

  return capacity + suffix
}

export const numFloorFixed = (value: number, toFixedNum = 1): string => {
  const fixedNum = Number(value.toFixed(toFixedNum))
  const floorNum: number = Math.floor(value)
  if (fixedNum - floorNum !== 0) {
    return `${fixedNum}`
  }
  return `${floorNum}`
}

// wei to ether
export const weiToEther = (weiString: string | number) => {
  const eth = new BigNumber(`${weiString}e-18`)
  return eth.toString()
}

/** 기획서 상 존재하는 소수점 자리 버림 숫지
 * 소수점 아래 8번째 자리까지 노출, 마지막 자리가 0인 경우 생략
 * */
const FIXED_NUMBER = 8

/**
 * @param {string | number} value - 변환될 숫자
 */
export const roundDownFixedPoint = (value: string | number) => {
  return BigNumber(value)
    .toFixed(FIXED_NUMBER, 1) // roundingMode : 1 = 내림
    .replace(/\.?0+$/, '')
}
